import { Box, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from 'react';
import '../../../style/SeatInfo.scss'
const SeatInfo = ({ data, targetRef }) => {
    const [modalWidth, setModalWidth] = useState('500');
    const fullRemark = data?.SysRemarks !== null ? data?.SysRemarks + data?.Remarks : data?.Remarks

    useEffect(() => {
        const updateWidth = () => {
            if (targetRef?.current) {
                const calculatedWidth = data?.seatInfo?.length > 1
                    ? `${window.innerWidth - 50 - targetRef.current.getBoundingClientRect().left}`
                    : 500;
                setModalWidth(calculatedWidth);
            }
        };
        updateWidth();
        window.addEventListener('resize', updateWidth);

        return () => {
            window.removeEventListener('resize', updateWidth);
        };
    }, [data?.seatInfo, targetRef]);
    const column1Data = [
        { name: "Name", field: 'PaxName' },
        { name: "Sector", field: 'RouteName' },
        { name: "Total", field: 'Total' },
        { name: "PNR/Ticket No", field: 'BookingID' },
        { name: "Maunal Ticket No", field: 'ManualTcktNo' },
        { name: "User", field: `UserBooked` },
        { name: "Booking Date", field: 'BookingDateFormated' },
        { name: "Pickup", field: 'PickupName' },
        { name: "Dropoff", field: 'DropoffName' },
        { name: "Remarks", field: 'Remarks' },
        { name: "Seats", field: 'AllSeats' },
        { name: "Pickup Charge", field: 'PickupCharge' },
        { name: "DropOff Charge", field: 'DropoffCharge' },
        { name: "Agent", field: 'AgentName' },
    ];

    return (
        <Box
            sx={{ width: Number(modalWidth) > 920 ? '920px' : `${modalWidth}px` }}
            className='seatInfoModal'
        >
            <Box className='header'>
                <Typography variant="body1" color="initial">Seat Info</Typography>
                <CloseIcon />
            </Box>
            <Box
                className="column-container"
                style={{
                    padding: "0px",
                }}
            >
                {data?.seatInfo.map((obj, index1) => (
                    <Box
                        className="column"
                        style={{ padding: "8px 16px", borderRight: data?.seatInfo?.length - 1 === index1 ? 'none' : "1px solid #00000033" }}
                    >
                        {column1Data.map((item, index) => (
                            <>
                                {['PickupCharge', 'DropoffCharge'].includes(item.field) && obj?.[item?.field] === 0 ? '' :
                                    <Typography variant="body1" style={{ display: "flex", alignItems: "start", marginBottom: "0px" }}>
                                        <span
                                            style={{ display: "inline-block", minWidth: "25%" }}
                                        >{`${item.name}`}</span>{" "}
                                        :{" "}
                                        <span style={{ paddingLeft: '4px', flex: 1 }}>
                                            {item.field === 'Total' ?
                                                `${Number(obj?.Fare) + Number(obj?.STax)}(${Number(obj.Fare)} + ${Number(obj?.STax)}GST)`
                                                :
                                                item?.field === 'BookingID' ?
                                                    `${obj?.BookingID || ''}${obj.TicketNo !== null ? '/' : ''}${obj.TicketNo || ''}`
                                                    :
                                                    item?.field === 'UserBooked' ?
                                                        ['BC', 'BP'].includes(obj.BookingType) ?
                                                            `${obj?.UserBookedFor || ''} ${obj.BranchBookedFor !== null ? '/' : ''} ${obj?.BranchBookedFor || ''} (${obj?.UserBooked || ''} ${obj.BranchBooked !== null ? '/' : ''} ${obj?.BranchBooked || ''})`
                                                            :
                                                            `${obj?.UserBooked || ''} ${obj.BranchBooked !== null ? '/' : ''} ${obj?.BranchBooked || ''}`
                                                        :
                                                        item?.field === 'PickupName' ?
                                                            `${obj?.PickupName || ''} ${obj.PickupDate !== null ? '/' : ''}${obj?.PickupDate || ''}`
                                                            :
                                                            item?.field === 'AllSeats' ?
                                                                `${obj?.AllSeats || ''}`
                                                                :
                                                                item?.field === 'Remarks' ?
                                                                    fullRemark
                                                                    :
                                                                    item?.field === 'PaxName' ?
                                                                        `${obj?.[item?.field]} (${obj?.PassengerContactNo1})`
                                                                        :
                                                                        obj?.[item?.field] || ''}
                                        </span>
                                    </Typography>
                                }
                            </>
                        ))}
                        {['P'].includes(obj.BookingType) &&
                            <Typography variant="body1" style={{ display: "flex", alignItems: "start", marginBottom: "0px" }}>
                                <span
                                    style={{ display: "inline-block", minWidth: "25%" }}
                                >{`Auto Cancellation Time`}</span>{" "}
                                :{" "}
                                <span style={{ paddingLeft: '4px', flex: 1 }}>
                                    {obj?.AutoCancellationTime || ''}
                                </span>
                            </Typography>
                        }
                    </Box>
                ))}


            </Box>
        </Box>
    )
}

export default SeatInfo